import React, { createContext } from 'react';

export const EnumsHookContext = createContext<{
  enumWrapperName: string | undefined;
}>({ enumWrapperName: undefined });

export const createWithEnumsHookContext = (enumWrapperName: string) => (
  WrappedComponent: React.FC<unknown>
) => (props: any) => {
  return (
    <EnumsHookContext.Provider value={{ enumWrapperName }}>
      <WrappedComponent {...props} />
    </EnumsHookContext.Provider>
  );
};
